import axios from 'axios';
import * as types from '../constants/ActionTypes';
import { isPartOfElmoExpTreatment, elmoTreatmentNames } from '../../lib/experiments-helper';

const suggestionsCache = {};

const resetSuggestions = () => ({ type: types.RESET_SUGGESTIONS });

const showSuggestions = () => ({ type: types.SHOW_SUGGESTIONS });

function requestSuggestions(text) {
  return {
    type: types.REQUEST_SUGGESTIONS,
    payload: { text },
  };
}

function receiveSuggestions(query, autoComplete) {
  return {
    type: types.RECEIVE_SUGGESTIONS,
    payload: { query, autoComplete },
  };
}

function receiveSuggestionsError() {
  return {
    type: types.RECEIVE_SUGGESTIONS_ERROR,
  };
}

function updateSuggestionsFromCache(query, autoComplete) {
  return {
    type: types.UPDATE_SUGGESTIONS_FROM_CACHE,
    payload: { query, autoComplete },
  };
}

function getSuggestions(query) {
  return (dispatch, getState) => {
    dispatch(requestSuggestions(query));

    const elmoTreatments = getState().app.elmoTreatments || [];
    let url = `/smarthelp/auto-complete?q=${query}`;

    // If is part of KM search experiment.
    if (isPartOfElmoExpTreatment(elmoTreatments, elmoTreatmentNames.kmSearchEnabled)) {
      url = `/smarthelp/km-search-auto-complete?q=${query}`;
    }

    return axios.get(url)
      .then((response) => {
        const { autoComplete } = response.data;
        if (autoComplete.length) {
          suggestionsCache[query] = autoComplete; // update the cache
        }

        dispatch(receiveSuggestions(query, autoComplete));
      })
      .catch(() => {
        dispatch(receiveSuggestionsError());
      });
  };
}

export const clearSuggestions = () => (dispatch) => {
  dispatch(resetSuggestions());
};

export const enableSuggestions = () => (dispatch) => {
  dispatch(showSuggestions());
};

export default function updateSuggestions(query) {
  return (dispatch) => {
    if (query in suggestionsCache) {
      dispatch(updateSuggestionsFromCache(query, suggestionsCache[query]));
    } else {
      dispatch(getSuggestions(query));
    }
  };
}
